import { useRef, useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api, API, apiError } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Presentation, Upload, Trash2, Loader2, Eye } from "lucide-react";
import { toast } from "sonner";
import { fmtDateTime } from "@/lib/constants";

export const PresentazioneAdmin = () => {
  const qc = useQueryClient();
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const { data } = useQuery({ queryKey: ["presentazione"], queryFn: async () => (await api.get("/public/presentazione")).data });

  const upload = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) { return; }
    if (file.size > 10 * 1024 * 1024) { toast.error("File troppo grande (max 10 MB)"); return; }
    const fd = new FormData();
    fd.append("file", file);
    setBusy(true);
    try { await api.post("/presentazione", fd); toast.success("Presentazione caricata"); qc.invalidateQueries({ queryKey: ["presentazione"] }); }
    catch (err) { toast.error(apiError(err.response?.data?.detail) || err.message); }
    finally { setBusy(false); }
  };

  const remove = async () => {
    if (!window.confirm("Rimuovere la presentazione? La Home tornerà ad aprire il link Gemini.")) { return; }
    await api.delete("/presentazione");
    toast.success("Presentazione rimossa");
    qc.invalidateQueries({ queryKey: ["presentazione"] });
  };

  return (
    <Card data-testid="presentazione-admin-card">
      <CardContent className="flex flex-col gap-4 p-5 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-3">
          <Presentation className="mt-0.5 h-5 w-5 text-[#166534]" />
          <div>
            <p className="font-heading font-semibold text-slate-900">Presentazione Corso di Formazione d'ingresso</p>
            <p data-testid="presentazione-admin-status" className="text-sm text-slate-500">
              {data?.available ? `${data.filename} · caricata ${fmtDateTime(data.uploaded_at)}` : "Nessun PDF caricato: la Home apre il link Gemini."}
            </p>
          </div>
        </div>
        <div className="flex flex-wrap gap-2">
          <input ref={inputRef} type="file" accept="application/pdf,.pdf" className="hidden" onChange={upload} data-testid="presentazione-file-input" />
          {data?.available && (
            <Button asChild variant="outline" size="sm"><a href={`${API}/public/presentazione/file`} target="_blank" rel="noopener noreferrer" data-testid="presentazione-view-button"><Eye className="mr-1 h-4 w-4" /> Apri</a></Button>
          )}
          <Button size="sm" onClick={() => inputRef.current?.click()} disabled={busy} className="bg-[#14382C] hover:bg-[#0E281F]" data-testid="presentazione-upload-button">
            {busy ? <Loader2 className="mr-1 h-4 w-4 animate-spin" /> : <Upload className="mr-1 h-4 w-4" />} {data?.available ? "Sostituisci PDF" : "Carica PDF"}
          </Button>
          {data?.available && (
            <Button size="sm" variant="outline" onClick={remove} className="text-red-700" data-testid="presentazione-delete-button"><Trash2 className="h-4 w-4" /></Button>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
